import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import actions from './actions';
import getters from './getters'
import mutations from './mutations';
import state from './state';

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'earbeater',
  storage: localStorage,
  reducer: (state) => (
    { userLevelsCompareIntervalSizes: state.userLevelsCompareIntervalSizes,
      userLevelsIdentifyIntervals: state.userLevelsIdentifyIntervals,
      userLevelsIdentifyChords: state.userLevelsIdentifyChords,
      userLevelsIdentifyChordInversions: state.userLevelsIdentifyChordInversions,
      userLevelsIdentifyScales: state.userLevelsIdentifyScales,
      standardExerciseScores: state.standardExerciseScores,
      gameSettings: state.gameSettings,
      accessToken: state.accessToken
    })
})

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexPersist.plugin]
})
